import script from "./platform.vue?vue&type=script&setup=true&lang=js"
export * from "./platform.vue?vue&type=script&setup=true&lang=js"

import "./platform.vue?vue&type=style&index=0&id=b2c13102&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b2c13102"]])

export default __exports__